import { StatusBadge } from '../components/StatusBadge';
import {
  resolveAllocationStatusUi,
  resolveImportStatusUi,
  resolvePaymentStatusUi,
  resolvePostingStatusUi,
  resolveRecognitionStatusUi,
  resolveReconciliationStatusUi,
} from './statusResolvers';
import { iconSizes } from '../icons/iconTypes';

function DomainStatusBadge({
  model,
  withIcon = true,
}: {
  model: ReturnType<typeof resolvePaymentStatusUi>;
  withIcon?: boolean;
}) {
  const Icon = model.icon;
  return (
    <StatusBadge
      label={model.label}
      tone={model.tone}
      withIcon={false}
      leftSection={withIcon ? <Icon size={iconSizes.inline - 4} stroke={2} /> : undefined}
    />
  );
}

export function PaymentStatusBadge({ status, fallbackLabel }: { status?: string; fallbackLabel?: string }) {
  return <DomainStatusBadge model={resolvePaymentStatusUi(status, fallbackLabel)} />;
}

export function PostingStatusBadge({ status, fallbackLabel }: { status?: string; fallbackLabel?: string }) {
  return <DomainStatusBadge model={resolvePostingStatusUi(status, fallbackLabel)} />;
}

export function AllocationStatusBadge({ status, fallbackLabel }: { status?: string; fallbackLabel?: string }) {
  return <DomainStatusBadge model={resolveAllocationStatusUi(status, fallbackLabel)} />;
}

export function ReconciliationStatusBadge({ status, fallbackLabel }: { status?: string; fallbackLabel?: string }) {
  return <DomainStatusBadge model={resolveReconciliationStatusUi(status, fallbackLabel)} />;
}

export function ImportStatusBadge({ status, fallbackLabel }: { status?: string; fallbackLabel?: string }) {
  return <DomainStatusBadge model={resolveImportStatusUi(status, fallbackLabel)} />;
}

export function RecognitionStatusBadge({ status, fallbackLabel }: { status?: string; fallbackLabel?: string }) {
  return <DomainStatusBadge model={resolveRecognitionStatusUi(status, fallbackLabel)} />;
}
